export const onSetActiveFilter = 'app/set-active-filter';
export const onSetCurrentProject = 'app/set-current-project';
